import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const Input = ({ className, innerRef, isInvalid, size, type, ...props }) => (
  <input
    ref={innerRef}
    type={type}
    className={classnames(className, { 'border-red': isInvalid }, 'form-control', size && `form-control-${size}`)}
    data-testid="Input"
    {...props}
  />
);

Input.propTypes = {
  className: PropTypes.string,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  isInvalid: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),
  type: PropTypes.string,
};

Input.defaultProps = {
  className: null,
  innerRef: null,
  isInvalid: false,
  size: null,
  type: 'text',
};

export default Input;
